import type { Step } from "@k8slens/lds-tips/lib/es/Tips/Steps";

import { TipContent } from "./TipContent";

import styles from "./Tip.module.css";

export const stepId = "add-lens-subscription";
export const targetId = `${stepId}-step`;

export const step: Step = {
  id: stepId,
  selector: `#${targetId}`,
  theme: "important",
  pointerClassName: styles.pointer,
  popupClassName: styles.popup,
  placement: "right-end",
  pointerOffset: [-28, -10],
  content: (
    <TipContent
      title="Create a subscription for your team!"
      content={[
        "To manage subscriptions, billing and assign licenses for your team, please create a new Subscription from here.",
        "You can always find your subscriptions and change the quantity of its seats from this list.",
      ]}
    />
  ),
};
